import {Language} from '../base/label-store';
import {Category} from '../questions/questions-store';

export const isCustomCategory = (categoryId: string): boolean => {
    const defaultCategories = [
        '1d3134f4-f87a-4aab-ab68-a8820926d2d1', // ENGAGEMENT
        'f5734cc5-7cc1-4f3a-af8a-8ca29b368599', // LEADERSHIP
        'f121e304-4760-46ae-8ffa-5d6ed03a9faf', // VALUES
        'ed64f370-7438-4f8d-95cc-b1514cfa5387', // INTERNAL_COMMUNICATION
        '765925e7-447c-44e6-8a74-7bc0e43f3259', // TIME_MANAGEMENT
        '7a3216d9-5aef-4db8-a609-bbe7d344ed5f', // JOB_DESIGN
        '705f70ab-b140-4d23-a2f3-a0ea9ad5df9a', // WORKING_ENVIRONMENT
        '1fb4ffc2-ef96-4b82-bee9-3a328e2875b2', // CULTURE
        '7af469f1-f760-4071-bbe7-a5a2532ce7a4', // RECOGNITION
        '5f65b88b-9ce3-4a42-b760-acf254c3bb9c', // LEARNING
        'ef80fd26-4c71-46c3-ab40-993934de0b62', // COMPENSATION
        '1d94cfb7-454e-4d45-9ed6-dad07fa19fca', // TRUST
        'f2ce1b0c-75a4-4181-9fc8-0de9dfaaf0fb', // MENTAL_HEALTH
        'ab8b314b-37ed-41e2-8b19-9f632d4d6189', // ONBOARDING
    ];

    return !defaultCategories.includes(categoryId);
};

export const getCategoryLanguage = (userLanguage: Language, category: Category): string => {
    switch (userLanguage) {
        case 'et':
            return category.textEstonian;
        case 'en':
            return category.textEnglish;
        case 'fi':
            return category.textFinnish;
        case 'lt':
            return category.textLithuanian;
        case 'lv':
            return category.textLatvian;
        case 'ru':
            return category.textRussian;
        case 'sv':
            return category.textSwedish;
        case 'pl':
            return category.textPolish;
        case 'ja':
            return category.textJapanese;
        case 'vi':
            return category.textVietnamese;
    }
};

export const getCategoryName = (userLanguage: Language, catId: string, categories?: Category[]): string => {
    const category = categories?.find((cat) => cat.id === catId);

    return category ? getCategoryLanguage(userLanguage!, category) : '';
};
